import { HERO_SCOOP } from '@/mocks/celebrity';

export default function Hero() {
  return (
    <section
      id="headline"
      className="relative overflow-hidden bg-gradient-to-b from-background-100 via-background-50 to-background-50"
    >
      {/* decorative warm blobs */}
      <div className="pointer-events-none absolute -right-24 top-10 h-80 w-80 rounded-full bg-accent-500/20 blur-3xl" />
      <div className="pointer-events-none absolute -left-16 bottom-0 h-72 w-72 rounded-full bg-primary-500/10 blur-3xl" />

      <div className="relative mx-auto max-w-[1200px] px-4 pb-14 pt-28 md:px-6 md:pt-32">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          {/* left: brand statement */}
          <div className="lg:col-span-6">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-flashlight-fill text-sm text-accent-600" />
              今日编辑部 · 已更新 12 条吃瓜速报
            </span>
            <h1 className="mt-5 font-heading text-4xl font-bold leading-[1.15] tracking-tight text-foreground-950 md:text-5xl">
              娱乐圈的恋情瓜，
              <span className="relative inline-block text-primary-600">
                一个都不错过
                <span className="absolute inset-x-0 bottom-1 h-3 -z-10 rounded bg-accent-500/40" />
              </span>
            </h1>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600">
              从<strong className="font-semibold text-foreground-900">恋情公开</strong>到
              <strong className="font-semibold text-foreground-900">约会实锤</strong>，从
              <strong className="font-semibold text-foreground-900">分手复合</strong>到
              <strong className="font-semibold text-foreground-900">感情线盘点</strong>，把零散物料整理成有依据、
              看得懂的时间线。下班刷一刷，今天的娱乐圈恋爱情报全部拿捏。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#feeds"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                进入栏目吃瓜
                <i className="ri-arrow-right-line ml-2 text-base" />
              </a>
              <a
                href="#love-line"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-accent-500/50 bg-accent-50 px-6 py-3 text-sm font-medium text-accent-700 transition-colors hover:bg-accent-500 hover:text-background-50"
              >
                <i className="ri-heart-3-line mr-2 text-base" />
                看感情线专题
              </a>
            </div>

            <dl className="mt-9 grid max-w-xl grid-cols-3 gap-4 border-t border-background-200 pt-6">
              {[
                { n: '1280+', t: '已盘点恋情瓜' },
                { n: '4', t: '核心栏目' },
                { n: '56', t: '感情线时间线' },
              ].map((s) => (
                <div key={s.t}>
                  <dt className="font-display text-2xl text-primary-600">{s.n}</dt>
                  <dd className="mt-1 text-xs text-foreground-600">{s.t}</dd>
                </div>
              ))}
            </dl>
          </div>

          {/* right: featured scoop card */}
          <article className="lg:col-span-6">
            <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <div className="relative">
                <img
                  src={HERO_SCOOP.image}
                  alt="明星深夜同返公寓被拍，恋情疑似实锤的编辑配图"
                  className="h-56 w-full object-cover object-top md:h-72"
                />
                <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
                  <i className="ri-fire-fill" />
                  {HERO_SCOOP.kicker}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 text-primary-600">
                    <i className="ri-time-line" />
                    {HERO_SCOOP.date}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {HERO_SCOOP.heat}
                  </span>
                </div>
                <h2 className="mt-2 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  {HERO_SCOOP.title}
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{HERO_SCOOP.summary}</p>
                <div className="mt-4 flex flex-wrap items-center gap-2">
                  {HERO_SCOOP.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800"
                    >
                      #{t}
                    </span>
                  ))}
                  <a
                    href="#feeds"
                    className="ml-auto inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
                  >
                    展开吃瓜细节
                    <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}